import PropTypes from "prop-types"
import React from "react"

import WorkOrdersTable from "./WorkOrdersTable"

const WorkOrders = ({ serviceBillingEnabled }) => (
  <div className="bg-white px-2 lg:px-6">
    <WorkOrdersTable serviceBillingEnabled={serviceBillingEnabled} />
  </div>
)

WorkOrders.propTypes = {
  serviceBillingEnabled: PropTypes.bool,
}

export default WorkOrders
